$(function () {
  $('.add-sub-product').on('click', function () {
    let id = $(this).attr('data-product');
    let weekFrequency = $(this).attr('data-weekFrequency');
    let shippingInterval = undefined;
    let sellingPlanId = $(this).attr('data-sellingPlanId');
    let sellingPlanGroupId = $(this).attr('data-sellingPlanGroupId');
    if (id === undefined && weekFrequency === undefined) {
      Toast.fire({
        icon: 'error',
        title: 'Please select all required ',
      });
      return false;
    }
    if (weekFrequency === '2') {
      shippingInterval = 'Week';
    } else if (weekFrequency === '1') {
      shippingInterval = 'Month';
    }

    let data = {
      quantity: 1,
      id: id,
      'properties[shipping_interval_frequency]': weekFrequency,
      'properties[shipping_interval_unit_type]': shippingInterval,
      'properties[Subscription Type]': 'Subscription',
      selling_plan: sellingPlanId,
    };
    /* console.log(data); */
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function (response) {
        console.log(data);

        window.location.href = '/cart';
      },
    });
  });

  const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-left',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });

  $('.pod-sub-selector input[type=radio]').on('change', function () {
    getPrice();
  });

  getPrice();
  function createHandle() {
    let $coffeeType = $('fieldset[name=coffee-type]')
      .find('input[type=radio]:checked')
      .val();
    let $coffeeTypeFinal = '';
    $coffeeType.split(' ').map((i) => {
      $coffeeTypeFinal += i.charAt(0);
    });

    $coffeeTypeFinal = $coffeeTypeFinal.slice(0, 2);
    if ($coffeeTypeFinal === 'DB') {
      $coffeeTypeFinal = 'DO';
    } else if ($coffeeTypeFinal === 'D') {
      $coffeeTypeFinal = 'DE';
    }
    let $size = $('fieldset[name=size]')
      .find('input[type=radio]:checked')
      .val()
      .toUpperCase();

    let $grind = $('fieldset[name=grind]')
      .find('input[type=radio]:checked')
      .val();
    let $grindFinal = '';
    $grind.split(' ').map((i) => {
      if (i !== '/') {
        $grindFinal += i.charAt(0);
      }
    });
    /* console.log("-> $grindFinal", $grindFinal); */

    $grindFinal = $grindFinal.substring(0, 2);
    let $frequency = $('fieldset[name=frequency]')
      .find('input[type=radio]:checked')
      .val();
    let $frequencyData = $('fieldset[name=frequency]')
      .find('input[type=radio]:checked')
      .attr('data-val');
    let $duration = $('fieldset[name=duration]')
      .find('input[type=radio]:checked')
      .val();
    // GIFT-250G-SO-WB-F2-12M
    let handle =
      'GIFT-' +
      $size +
      '-' +
      $coffeeTypeFinal +
      '-' +
      $grindFinal +
      '-' +
      $frequency +
      '-' +
      $duration;
    /* console.log("-> %c sku:"+handle , 'background:#242424;color:#f2d823;padding:10px');
        console.log("%c https://kissthehippo02.myshopify.com/admin/products?selectedView=all&status=ACTIVE&query="+handle , 'background:#f4f4f4;color:#b52735 !important;padding:10px'); */
    $('.add-sub-product').attr('data-weekFrequency', $frequencyData);
    console.log("handle",handle)
    return handle;
  }

  function getPrice() {
    let handle = createHandle();
    let newData = `
        query 
              {
  products(first: 1, query: "${handle}") {
    edges {
      node {
        id
        title
        handle
        variants(first: 100) {
          edges {
            node {
              id
              title
              sku
              price{
                amount
              }
            }
          }
        }
        sellingPlanGroups(first: 100) {
          nodes {
            sellingPlans(first: 100) {
              edges {
                node {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
}
            
        `;
    // console.log("-> newData", newData);
    let settings = {
      async: true,
      crossDomain: true,
      url: 'https://kissthehippo.com/api/graphql',
      method: 'POST',
      headers: {
        'X-Shopify-Storefront-Access-Token': '0e36ba692f2790e09720af79e43dd849',
        'Content-Type': 'application/graphql',
      },
      data: newData,
    };

    return $.ajax(settings)
      .done(function (response) {
        /* console.log("-> response", response); */
        let product = response.data.products.edges[0].node.title;
        let selling_plan;
        let variants = response.data.products.edges[0].node.variants.edges;
         console.log("-> variants", variants); 
        let price,
          id,
          title = '';
        variants.map(function (value) {
       if(handle== value.node.sku){
            price = value.node.price.amount;
            id = value.node.id;
            title = value.node.title;
            selling_plan =
              response.data.products.edges[0].node.sellingPlanGroups.nodes[0].sellingPlans.edges[0].node.id.replace(
                'gid://shopify/SellingPlan/',
                '',
              );}
          
        });
        price = Number(price).toFixed(2);
        /* console.log("-> product", product);
            console.log("-> price", price);
            console.log("-> variantTitle", title);
            console.log("-> id", id); */
        // const adminGraphqlId = atob(id);
        let activeVariantId = id.split('ProductVariant/')[1];
         console.log("-> activeVariantId", activeVariantId); 
        $('.product__price__wrap').show();
        $('.product__price__main').show();
        $('.product__price span')
          .empty()
          .append('£' + price);
        $('.add-sub-product').attr('data-product', activeVariantId);
         $('.add-sub-product').attr('data-sellingPlanId', selling_plan);
        console.log('-> activeVariantId', activeVariantId);
      })
      .error(function (err) {
        Toast.fire({
          icon: 'error',
          title: 'Please choose options slower',
        });
        return false;
      });
  }
});
